import type { PageContext } from 'vike/types';
import {
  buildBestCompaniesHubSeo,
  inferBestCompaniesLocaleFromPathname,
  normalizeBestCompaniesLocale,
} from '../../utils/seo/best-companies-meta';

function pathnameFromPageContext(pageContext: PageContext): string {
  const urlOriginal = (pageContext as any).urlOriginal || '/';
  if (typeof urlOriginal === 'string' && urlOriginal.startsWith('http')) {
    try {
      return new URL(urlOriginal).pathname;
    } catch {
      return '/';
    }
  }
  return String(urlOriginal || '/');
}

export default function title(pageContext: PageContext): string {
  const pathname = pathnameFromPageContext(pageContext);
  const fromPath = inferBestCompaniesLocaleFromPathname(pathname);
  const locale = normalizeBestCompaniesLocale((pageContext as any).locale || fromPath);
  return buildBestCompaniesHubSeo(locale).title;
}
